import { JSONSchema } from "./types";

export const makeAllFieldsOptional = (schema: JSONSchema): JSONSchema => {
  if ("required" in schema) {
    schema.required = [];
  }
  if ("properties" in schema) {
    for (const key in schema.properties) {
      makeAllFieldsOptional(schema.properties[key]);
    }
  }
  if ("items" in schema && typeof schema.items === "object") {
    makeAllFieldsOptional(schema.items);
  }
  if ("allOf" in schema) {
    schema.allOf.forEach((subSchema: JSONSchema) =>
      makeAllFieldsOptional(subSchema)
    );
  }
  if ("oneOf" in schema) {
    schema.oneOf.forEach((subSchema: JSONSchema) =>
      makeAllFieldsOptional(subSchema)
    );
  }
  if ("anyOf" in schema) {
    schema.anyOf.forEach((subSchema: JSONSchema) =>
      makeAllFieldsOptional(subSchema)
    );
  }
  return schema;
};

export const removeAdditionalProperties = (schema: JSONSchema): JSONSchema => {
  if ("additionalProperties" in schema) {
    delete schema["additionalProperties"];
  }

  if ("properties" in schema) {
    for (const key in schema.properties) {
      removeAdditionalProperties(schema.properties[key]);
    }
  }

  if ("items" in schema && typeof schema.items === "object") {
    removeAdditionalProperties(schema.items);
  }
  if ("allOf" in schema) {
    schema.allOf.forEach((subSchema: JSONSchema) =>
      removeAdditionalProperties(subSchema)
    );
  }

  if ("oneOf" in schema) {
    schema.oneOf.forEach((subSchema: JSONSchema) =>
      removeAdditionalProperties(subSchema)
    );
  }

  if ("anyOf" in schema) {
    schema.anyOf.forEach((subSchema: JSONSchema) =>
      removeAdditionalProperties(subSchema)
    );
  }
  return schema;
};
